import React from "react";
import Home from "./index";
import { HomeModel } from "./types";
import { Product } from "../../context/product-context/product";

export default function HomeLocalStateAdapter({
  homeModel,
  onNext,
  handleOnProductFamilySelection,
}: {
  homeModel: HomeModel;
  onNext: (homeModel: HomeModel) => void;
  handleOnProductFamilySelection: (product: Product) => void;
}): React.JSX.Element {
  return (
    <Home
      initial={homeModel}
      next={onNext}
      handleOnProductFamilySelection={handleOnProductFamilySelection}
    />
  );
}
